import { useEffect, useState } from "react";
import axios from "axios";
import { Package, RefreshCw, Loader2 } from "lucide-react";
import { AiMockupSummary } from "./ai_mockup_summary";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TONE = { "Cukup": "ok", "Kurang": "warn", "Kosong": "bad", "Perlu Dicek": "check", "Sudah Diambil": "ok", "Bukan Stok": "muted", "Periksa Manual": "check", "Ditahan": "muted", "Dibatalkan": "muted" };
const n = (x) => (x === null || x === undefined ? "—" : Number.isInteger(x) ? x : Number(x).toFixed(1));

// Kebutuhan Barang per pekerjaan (Gudang Rido). BACA SAJA — tidak memotong stok.
export function WhNeedsPanel({ jobId, canRebuild = true }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [ai, setAi] = useState(null);
  const load = async (rebuild = false) => {
    axios.get(`${API}/ai-mockup-read/job/${jobId}`, { withCredentials: true }).then(r => setAi(r.data.read)).catch(() => setAi(null));
    setBusy(true); setErr("");
    try {
      const r = rebuild ? await axios.post(`${API}/shopee/${jobId}/needs/rebuild`, {}, { withCredentials: true })
        : await axios.get(`${API}/shopee/${jobId}/needs`, { withCredentials: true });
      setData(r.data);
    } catch (e) { setErr(e?.response?.data?.detail || "Gagal memuat kebutuhan barang."); }
    finally { setBusy(false); }
  };
  useEffect(() => { if (open && !data) load(); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const s = data?.summary;
  return <div className="whn" onClick={e => e.stopPropagation()} data-testid={`wh-needs-${jobId}`}>
    <button type="button" className="whn-toggle" aria-expanded={open} onClick={() => setOpen(v => !v)} data-testid={`wh-needs-toggle-${jobId}`}>
      <Package size={14}/> Kebutuhan Barang {open ? "▴" : "▾"}
    </button>
    {open && <div className="whn-body">
      {busy && !data && <div className="muted small"><Loader2 size={12} className="spin"/> Memuat…</div>}
      {err && <div className="warn-box small" data-testid={`wh-needs-err-${jobId}`}>{err}</div>}
      {data && <>
        {data.block && <div className="whn-note" data-testid={`wh-needs-block-${jobId}`}>Pesanan {data.block} — barang tidak dihitung &amp; tidak boleh diambil.</div>}
        {data.stale && <div className="whn-note" data-testid={`wh-needs-stale-${jobId}`}>Mockup direvisi — periksa ulang daftar ini.</div>}
        {data.missing || !data.lines.length
          ? <div className="muted small" data-testid={`wh-needs-empty-${jobId}`}>{data.missing ? "Daftar belum disusun." : "Data pesanan belum memuat item/ukuran/jumlah."} Status: Perlu Dicek.</div>
          : <table className="whn-table" data-testid={`wh-needs-table-${jobId}`}>
            <thead><tr><th>Produk</th><th>Warna</th><th>Ukuran</th><th>Butuh</th><th>Sudah Keluar</th><th>Sisa</th><th>Stok Tersedia</th><th>Status</th></tr></thead>
            <tbody>{data.lines.map((l, i) => <tr key={i} data-testid={`wh-needs-row-${jobId}-${i}`}>
              <td>{l.variant_label ? l.variant_label.split(" · ")[0] : (l.product || "—")}{l.sku && <small className="muted"> {l.sku}</small>}</td>
              <td>{l.color || "—"}</td><td>{l.size || "—"}</td><td>{l.qty}</td><td data-testid={`wh-needs-issued-${jobId}-${i}`}>{n(l.issued)}</td><td data-testid={`wh-needs-remaining-${jobId}-${i}`}>{n(l.remaining)}</td><td>{n(l.available)}</td>
              <td><span className={`whn-st is-${TONE[l.status] || "check"}`} title={(l.checks || []).join(" · ")}>{l.status}</span>
                {l.status === "Perlu Dicek" && l.checks?.[0] && <small className="whn-why">{l.checks[0]}</small>}
                {l.note && <small className="whn-why">{l.note}</small>}</td>
            </tr>)}</tbody>
          </table>}
        {s && <div className="whn-sum" data-testid={`wh-needs-sum-${jobId}`}>Total butuh <b>{s.need_pcs}</b> pcs{s.issued_pcs ? ` · Sudah keluar ${s.issued_pcs} · Sisa ${s.remaining_pcs}` : ""} · <b>{shortTxt(s.shortage_pcs, s.check)}</b>{s.check ? ` · ${s.check} baris Perlu Dicek` : ""}{s.excess_pcs ? ` · Keluar melebihi kebutuhan ${s.excess_pcs} pcs (periksa)` : ""}</div>}
        <AiMockupSummary read={ai} tid={`job-${jobId}`} canReread={canRebuild} />
        {canRebuild && <button type="button" className="soft-btn small-btn" onClick={() => load(true)} disabled={busy} data-testid={`wh-needs-rebuild-${jobId}`}>
          <RefreshCw size={12}/> Susun Ulang</button>}
        <div className="muted small">Stok belum dipotong. Pengambilan barang dikonfirmasi pada tahap berikutnya.</div>
      </>}
    </div>}
  </div>;
}

// Kekurangan hanya pasti bila tidak ada baris Perlu Dicek — jangan tampilkan "Kurang 0 pcs" saat data belum lengkap.
const shortTxt = (short, check) => (check ? (short ? `Kurang ≥${short} pcs · sisanya belum dapat dipastikan` : "Stok belum dapat dipastikan") : `Kurang ${short} pcs`);

export { WhNeedsSummaryBar } from "./needs_board";
